// Pure predicate used by the AuthContext's hasFeature() implementation.
// Kept standalone so it is trivially unit-testable without React.
// A feature is off unless its flag is exactly true; with `defaultOn` it is on
// unless the flag is exactly false (a per-user opt-out).
export function computeHasFeature(
  metadata: { feature_flags?: Record<string, boolean> } | null | undefined,
  feature: string,
  defaultOn = false
): boolean {
  const flag = metadata?.feature_flags?.[feature];
  return defaultOn ? flag !== false : flag === true;
}
